import { createActions } from 'redux-actions'

export const {
  loader: { updateData }
} = createActions({
  '@loader/updateData': data => ({ data })
})
